import classNames from "classnames";
import React from "react";
import { Tooltip } from "antd";
import "./TwoLineText.scss";

export interface TwoLineTextProps {
  /**Used to change style Component */
  className?: string;
  /**URL of avatar to display */
  avatar?: string;
  /**Shape option of avatar*/
  avatarType?: "circle" | "square";
  /** Icon name to display */
  icon?: string;
  /** Display value of line 1*/
  valueLine1?: string;
  /** Display value of line 2*/
  valueLine2?: string;
  /** ClassName to style for display line 1 */
  classNameFirstLine?: string;
  /** ClassName to style for display line 2 */
  classNameSecondLine?: string;
  /**Option to add link into cell */
  link?: string;
  // /** Count max length to display of line 1 */
  // countCharacters1?: number;
  // /** Count max length to display of line 2 */
  // countCharacters2?: number;
  /**Use tooltip for data in cell */
  useTooltip?: boolean;
}

function TwoLineText(props: TwoLineTextProps) {
  const {
    className,
    avatar,
    avatarType = "circle",
    valueLine1,
    icon,
    valueLine2,
    classNameFirstLine,
    classNameSecondLine,
    link,
    useTooltip = true,
  } = props;

  const getFrameStyle = React.useMemo(() => {
    if (avatar) {
      return { width: "calc(100% - 40px)" };
    } else if (icon) {
      return { width: "calc(100% - 24px)" };
    }
    return { width: "100%" };
  }, [avatar, icon]);

  return (
    <>
      <div className={classNames("cell-two-line", className)}>
        {avatar &&
          <img
            src={avatar}
            className={classNames(
              `avatar-two-line-text m-r--2xs`,
              `avatar-type-${avatarType}`
            )}
            alt="avatar"
          />
        }
        <div className="frame-text" style={getFrameStyle}>
          <div
            className={classNames(classNameFirstLine, "line-text first-line")}
          >
            {icon && (
              <i
                className={classNames(icon, `icon-two-line-text m-r--2xs`)}
              ></i>
            )}
            <div className="w100pc-32px">
              {useTooltip ? (
                <Tooltip title={valueLine1} placement="topLeft">
                  <div className="text-ellipsis">{valueLine1}</div>
                </Tooltip>
              ) : (
                <div className="text-ellipsis">{valueLine1}</div>
              )}
            </div>
          </div>
          <div
            className={classNames(
              "line-text second-line",
              classNameSecondLine,
              icon ? "m-l--lg" : ""
            )}
          >
            {link ? (
              <a href={link} rel="noopener noreferrer" className="link-text w100pc-32px">
                {useTooltip ? (
                  <Tooltip title={valueLine2} placement="topLeft">
                    <div className="text-ellipsis">{valueLine2}</div>
                  </Tooltip>
                ) : (
                  <div className="text-ellipsis">{valueLine2}</div>
                )}
              </a>
            ) : (
              <div className="w100pc">
                {useTooltip ? (
                  <Tooltip title={valueLine2} placement="topLeft">
                    <div className="text-ellipsis">{valueLine2}</div>
                  </Tooltip>
                ) : (
                  <div className="text-ellipsis">{valueLine2}</div>
                )}
              </div>
            )}
          </div>
        </div>
      </div >
    </>
  );
}
export default TwoLineText;
